export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
      url: 'static/img/toyBear.JPG',
      activeName: 'first',

      nickname: "littlebear",
      welcom_word: "欢迎来访!这里是littlebear的主页",
      introduction_word: "我是一名计算机/ACGN爱好者, 喜欢计算机，艺术，游戏，动漫，目前在四川省成都市。",
      link_word: "以下是我建立或参与的一些站点：",
      email: "littlesunnybear@foxmail.com",
      public_site_word: "公网站点链接：",

    }
  }
}


// WEBPACK FOOTER //
// ./src/components/js/App.js